import { combineReducers } from "redux";
import analyticsPage from "components/Pages/AnalyticsPage/reducer";

import analyticsAnswers
  from "components/Pages/AnalyticsPage/AnalyticsReportsPage/AnalyticsSingleReportPage/AnalyticsAnswersPage/reducer";
import analyticsConversations
  from "components/Pages/AnalyticsPage/AnalyticsReportsPage/AnalyticsSingleReportPage/AnalyticsConversationsPage/reducer";
import analyticsSatisfaction
  from "components/Pages/AnalyticsPage/AnalyticsReportsPage/AnalyticsSingleReportPage/AnalyticsSatisfactionPage/reducer";

import analyticsOverviewPage from "components/Pages/AnalyticsPage/AnalyticsOverviewPage/reducer";

export default combineReducers({
  analyticsAnswers,
  analyticsPage,
  analyticsConversations,
  analyticsSatisfaction,
  analyticsOverviewPage
});
